import { Injectable } from 'framework/di';

import type { CartResponse } from '../../providers/shopify';
import { BoostAPI } from '../app/app.api';
import { AppService } from '../app/app.service';
import { PlatformLoader } from '../platform/platform.loader';

@Injectable
export class CartAPI extends BoostAPI {
  constructor(
    private appService: AppService,
    platformLoader: PlatformLoader
  ) {
    super(platformLoader);
  }

  getCart() {
    const url = this.buildEndpointWithLocale('cart.js');
    return this.get<CartResponse>(url).then((res) => ({
      ...res,
      data: typeof res.data === 'string' ? JSON.parse(res.data) : res.data,
    }));
  }

  async getProductsInCart() {
    const response = await this.getCart();
    return response.data.items || [];
  }
}
